import { yupResolver } from "@hookform/resolvers/yup";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useForm } from "react-hook-form";
import * as yup from "yup";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import { changePassword } from "api/auth";
import HeaderCard from "components/DataTable/HeaderCard";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

// Yup schema
const schema = yup.object({
  current_password: yup
    .string()
    .required("Current password is required")
    .min(6, "Minimum 6 characters"),
  password: yup
    .string()
    .required("New password is required")
    .min(6, "Minimum 6 characters"),
  password_confirmation: yup
    .string()
    .required("Please confirm new password")
    .oneOf([yup.ref("password")], "Passwords do not match"),
});

const ChangePassword = () => {
    const navigate = useNavigate();
    const {
        register,
        handleSubmit,
        reset,
        formState: { isSubmitting, errors }
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            current_password: "",
            password: "",
            password_confirmation: ""
        }
    });

    const onSubmit = async (data) => {
        const { password, password_confirmation } = data;
        if (password !== password_confirmation) {
            toast.error("Passwords do not match");
            return;
        }

        try {
            await changePassword(data);
            toast.success("Password changed successfully");
            reset();
        } catch (err) {
            toast.error(err?.data?.message || "Failed to change password");
        }
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={4} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <HeaderCard title="Change Password" />
                            <form noValidate onSubmit={handleSubmit(onSubmit)}>
                                <MDBox pt={3} px={2} pb={2}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <Grid item xs={12} md={6}>
                                                <MDInput
                                                    fullWidth
                                                    label="Current Password"
                                                    type="password"
                                                    required
                                                    {...register("current_password")}
                                                    error={!!errors.current_password}
                                                    helperText={errors.current_password?.message}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <MDInput
                                                fullWidth
                                                label="New Password"
                                                type="password"
                                                required
                                                {...register("password")}
                                                error={!!errors.password}
                                                helperText={errors.password?.message}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <MDInput
                                                fullWidth
                                                label="Confirm New Password"
                                                type="password"
                                                required
                                                {...register("password_confirmation")}
                                                error={!!errors.password_confirmation}
                                                helperText={errors.password_confirmation?.message}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <MDBox display="flex" justifyContent="flex-end">
                                                <MDButton
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    loading={isSubmitting}
                                                >
                                                    Change Password
                                                </MDButton>
                                            </MDBox>
                                        </Grid>
                                    </Grid>
                                </MDBox>
                            </form>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    );
};

export default ChangePassword;
